// extracted by mini-css-extract-plugin
export var divider = "_mu-0";
export var systemMessage = "_mu-1";
export var systemMessageWrapper = "_mu-2";